import { render, staticRenderFns } from "./liabilities-page.vue?vue&type=template&id=74140a40&scoped=true"
import script from "./liabilities-page.vue?vue&type=script&lang=ts"
export * from "./liabilities-page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74140a40",
  null
  
)

export default component.exports